<template>
  <div class="d-flex flex-row align-items-center min-vh-100 login-background c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol sm="12" md="8" xl="6">
          <CCard class="p-4">
            <CCardBody>
              <h1>{{$t("login")}}</h1>
              <p class="text-muted">Redirecting to the PRO global login...</p>
              <CButton color="primary" @click="continueToLogin">
                {{$t("login")}}
              </CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
  import {dashboardReturnUrl, isLoggedInByCookie, redirectToLogin} from '@/services/sso'

  export default {
    name: 'Login',
    mounted () {
      if (isLoggedInByCookie()) {
        this.$store.dispatch('setLoggedIn', true)
        window.location.replace(dashboardReturnUrl(this.$route))
        return
      }

      this.continueToLogin()
    },
    methods: {
      continueToLogin () {
        redirectToLogin(this.$route, true)
      }
    }
  }
</script>
